import objectAssign from 'object-assign';
import initialState from './initialState';
import { 
  GET_VEHICLE_LIST_REQUEST,
  GET_VEHICLE_LIST_SUCCESS,
  GET_VEHICLE_LIST_FAILURE
} from '../constants/actionTypes';

export default function vehiclesReducer(state = initialState.vehicles, action) {
    switch (action.type) {
      case GET_VEHICLE_LIST_REQUEST:
        return objectAssign({}, state, { isFetching: true });

      case GET_VEHICLE_LIST_SUCCESS:
        return objectAssign({}, state, {
          isFetching: false,
          list: action.data,
          error: null
        });

      case GET_VEHICLE_LIST_FAILURE:
        return objectAssign({}, state, {
          isFetching: false,
          error: action.error
        });

      default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/vehiclesReducer.js